module.exports = __webpack_public_path__ + "static/img/celoscope-5.8477b9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-5.jpg
// module id = 2oiI
// module chunks = 51